import { Component, OnInit, ViewChild } from '@angular/core';

import { HttpClient, HttpEventType, HttpResponse } from '@angular/common/http';
import { Observable, of, pipe, timer } from 'rxjs';
import { LargereceiptService } from '../service/largereceipt.service';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxFileDropEntry, FileSystemFileEntry, FileSystemDirectoryEntry } from 'ngx-file-drop';

import { FormControl } from "@angular/forms";
import { FileValidators } from "ngx-file-drag-drop";
import { HeaderComponent } from '../header/header.component';
import { IReceiptFileUploadDetails, ISenderDetails, ResultContent_ReceiptFileUpload } from '../class/largereceipt';
import { AppError } from '../common/class/app-error';
import { TranslationLoaderService } from '../common/translation-loader.service';
import { UserSessionService } from '../common/user-session.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import {ThemePalette} from '@angular/material/core';
import {ProgressBarMode} from '@angular/material/progress-bar';
import { catchError } from 'rxjs/operators';
import { CommonUtilService } from '../service/common-util.service';


@Component({
  selector: 'app-receipt-authentication',
  templateUrl: './receipt-authentication.component.html',
  styleUrls: ['./receipt-authentication.component.scss']
})
export class ReceiptAuthenticationComponent implements OnInit {
  currentFile?: File;
  progress = 0;
  message = '';
 
  files?:string[]; 
  validationMessages!: string;
  uploadImageUrl:string = "../../assets/Images/upload_img.png";
  fileSize!: string;
  @ViewChild(HeaderComponent) headerComponent : HeaderComponent;
  public  resultContentObj=new ResultContent_ReceiptFileUpload();
  senderDetailsSnapShot:ISenderDetails;
  messageId: string;
  isEligibleforAuthentication:boolean;
  fileId:string;
  senderAddress:string;
  historyId:string;
  appLang:string;
  color: ThemePalette = 'primary';
  mode: ProgressBarMode = 'indeterminate';
  value = 50;
  bufferValue = 75;
  showProgressBar:boolean=false;
  fileNameToDisplay:string;
  showSuccessMessage:boolean=false;
  showError:boolean=false;
  errorMessage:string;
  deleteIconPath:string="../../assets/Images/DeleteIcon.png";
  constructor(private largeReceiptService: LargereceiptService,private http: HttpClient,private router:Router
    , private route: ActivatedRoute
    ,private translate: TranslateService
    ,private langSvc: TranslateService
    ,private langLoaderSvc: TranslationLoaderService
    ,private user: UserSessionService
    ,private commonUtilSvc:CommonUtilService
    ) { 
      
      this.route.params.subscribe( params => this.messageId=(params.messageId));
      //alert('QS'+this.messageId)
      localStorage.setItem("MessageId",this.messageId);
      localStorage.removeItem("OriginalUrl");
    }

  

  
  ngOnInit(): void {
   
    if(this.route.snapshot.data.senderDetails!=undefined)
    {
      this.senderDetailsSnapShot=this.route.snapshot.data.senderDetails;
      this.isEligibleforAuthentication=this.senderDetailsSnapShot.ResultContent.IsEligibleforAuthentication;
      this.senderAddress=this.senderDetailsSnapShot.ResultContent.SenderAddress;
      localStorage.setItem("Eligibility_"+this.historyId,new Boolean(this.isEligibleforAuthentication).toString());
      localStorage.setItem("SenderAddress_"+this.historyId,this.senderAddress);
      this.appLang=this.senderDetailsSnapShot.ResultContent.Language;
      if(this.appLang ==null)
      {
        this.appLang='en-us';
      }
    }
    else
    {
      this.appLang='en-us';
    }
    this.langSvc.setDefaultLang(this.appLang);
    localStorage.setItem('appLang',this.appLang);
    this.InitLang();
    this.commonUtilSvc.hideSpinner();
  }

  InitLang() {
    const lang =  this.user.getAppLanguage();
    const browserLang = navigator.language.toLowerCase();
    if (lang === browserLang) {
      this.langLoaderSvc.use(lang);
      this.appLang = lang;
    } else {
      this.langLoaderSvc.use(lang);
      this.appLang = browserLang;
    }
  }

      
  DisplayErrorMessage(errorMessage:string)
  {
    this.showError=true;
    this.errorMessage=errorMessage;

  }

  HideErrorMessage()
  {
    this.showError=false;
    this.errorMessage='';

  }

  async Authenticate()
  {
    this.EnableUploadButton();
    if(this.currentFile==undefined)
    {
      this.DisplayErrorMessage(this.translate.instant('ReceiptAuthentication.NoFileValidationMsg'));
      
    }
    else if(await this.VerifyEligibilityToAuthenticate(this.messageId)==false)
    {
      
      this.DisplayErrorMessage(this.translate.instant('ReceiptAuthentication.NoUnitsMsgPageLoad'));
      
    }
    else
    {
      this.HideErrorMessage();
      this.commonUtilSvc.showSpinner();
      //Call Authenticate API
      this.currentFile = undefined;
      let fileName=this.resultContentObj.FileName;
      let fileId= this.resultContentObj.FileId;
      this.largeReceiptService.authenticateFile(fileName,fileId)
      .subscribe(async resp => {
        
        if (!(resp instanceof AppError)) {      
          
          const response = resp as unknown as IReceiptFileUploadDetails;
           const result = await response.ResultContent;
           this.resultContentObj=result;
           if(response.Status=="Success")
           {
            this.commonUtilSvc.hideSpinner(); 
            
            //Swal.fire('Submitted',this.translate.instant("ReceiptAuthentication.SuccessMsg"),'success',3000);
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: this.translate.instant("ReceiptAuthentication.SuccessMsg"),
              showConfirmButton: false,
              timer: 3000
            })
            
            this.ClearFileDetails();
           }
           
      }
      else
      {
        this.commonUtilSvc.hideSpinner();
        const response = resp as AppError;
        let errorMessage=this.translate.instant('ReceiptAuthentication.GenericErrorMsg');
        this.DisplayErrorMessage(errorMessage);
        // this.DisplayErrorMessage(response.Message);

      }
    });
      

    }

  }
  PerformValidations(selectedFile:File,fileExtention?:string):string
  {
    let message:string="Valid";
    if(fileExtention=="eml" || fileExtention=="msg")
    {
      message="Valid";
    }
    else
    {
      this.fileNameToDisplay=undefined;
      this.showProgressBar=false;
      message= this.translate.instant('ReceiptAuthentication.FileFormatValidationMsg'); //"The uploaded file format is not supported by the system";
    }
       
    return message;
  }

  UploadFileToServer(file:File):string
  {
    this.showProgressBar=true;
    this.HideErrorMessage();
    this.progress = 0;
    let fileExtension=file.name.split('.').pop(); 
    this.validationMessages=this.PerformValidations(file,fileExtension);
    if(this.validationMessages=="Valid")
    {

      this.largeReceiptService.uploadReceipt(file).subscribe(
        (event: any) => {
          this.showProgressBar=false;
          const response = event as unknown as IReceiptFileUploadDetails;
          const result =  response.ResultContent;
          this.resultContentObj=result;  
          this.fileId=this.resultContentObj.FileId;
          this.progress = Math.round(100);
          this.fileNameToDisplay = file.name;
          this.fileSize= this.BytesToSize(file.size);
          this.currentFile = file;
          this.DisableUploadButton();
     

        },
        (err: any) => {
          console.log(err);
          this.progress = 0;
          
          if (err.error ) {
            
            //this.message=err.error.message;
            this.message=this.translate.instant('ReceiptAuthentication.GenericErrorMsg');
          } else {
            this.message = this.translate.instant('ReceiptAuthentication.GenericErrorMsg');;
          }
          this.EnableUploadButton();
          
        });
    }
    else
    {
      this.ClearFileDetails();
      this.DisplayErrorMessage(this.validationMessages);
      this.EnableUploadButton();
    }
    
    return this.validationMessages;
  }

 

  public Dropped(files: NgxFileDropEntry[]) {
    this.HideErrorMessage();
    
    if(this.fileNameToDisplay!=undefined)
    {
      
      this.DisplayErrorMessage(this.translate.instant('ReceiptAuthentication.MorethanOneFileValidationMsg'));
    }
    else
    {
      this.HideErrorMessage();
      for (const droppedFile of files) {

      
        if (droppedFile.fileEntry.isFile) {
          const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
          fileEntry.file((file: File) => {
            
            //console.log(droppedFile.relativePath, file);
            
            let validationMessage=this.UploadFileToServer(file);
            
          });
        } else {
          
          const fileEntry = droppedFile.fileEntry as FileSystemDirectoryEntry;
          //console.log(droppedFile.relativePath, fileEntry);
        }
      }

    }
    
  }

  public fileOver(event: any){
    console.log(event);
    this.HideErrorMessage();
  }

  public fileLeave(event: any){
    console.log(event);
    this.HideErrorMessage();
  }

  
  DeleteFile()
  {
    
    this.HideErrorMessage();
    this.showProgressBar=false;
    let fileName=this.fileId;
    Swal.fire({
      title: 'Are you sure you want to delete the file?',
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    }).then((result) => {
      if (result.value) {
        this.commonUtilSvc.showSpinner();
      this.largeReceiptService.deleteFile(fileName)
      .subscribe(async resp => {
        
        if (!(resp instanceof AppError)) {      
          
          const response =resp as IReceiptFileUploadDetails
          
          
          this.ClearFileDetails();
          this.EnableUploadButton();

          Swal.fire({
            position: 'center',
            icon: 'success',
            title: this.translate.instant("ReceiptAuthentication.DeleteFileSuccessMsg"),
            showConfirmButton: false,
            timer: 3000
          })
      }
      else
      {
        this.commonUtilSvc.hideSpinner();
        const response = resp as AppError;
        this.DisplayErrorMessage(response.Message);

      }
    });
      this.commonUtilSvc.hideSpinner();
     
        
      } 
      
      
    })
    

    

  }

  BytesToSize(bytes: number) {
    var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes == 0) return '0 Byte';
    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)).toString());
    return Math.round(bytes / Math.pow(1024, i) +1) + ' ' + sizes[i];

 }

 async VerifyEligibilityToAuthenticate(messageId:string)
 {
   let eligibleToAuthenticate:boolean=false;
   var resp =await this.largeReceiptService.getSenderDetails(messageId).toPromise();
      const response =resp as unknown as ISenderDetails;
    eligibleToAuthenticate=response.ResultContent.IsEligibleforAuthentication;
      
   pipe(
   catchError(error => {
     let errorDescription=error;
     this.router.navigate(['/ErrorPage',error]);
       return of(null);
   })
 );

  return eligibleToAuthenticate;
 }

 ClearFileDetails()
 {
          this.fileNameToDisplay=undefined;
          this.progress=0;
          this.currentFile=undefined;

 }

 DisableUploadButton()
 {
  $("#btnUpload").prop("disabled", true);


 }
 EnableUploadButton()
 {

  $("#btnUpload").removeAttr('disabled');
 }
 

}
